export var MetadataElementIdConstants;
(function (MetadataElementIdConstants) {
    MetadataElementIdConstants["GLOBAL_BinderId"] = "GLOBAL_BinderId";
    MetadataElementIdConstants["GLOBAL_BinderType"] = "GLOBAL_BinderType";
    MetadataElementIdConstants["GLOBAL_LanguageString"] = "GLOBAL_Language";
    MetadataElementIdConstants["GLOBAL_QuestionDueDateId"] = "GLOBAL_QuestionDueDate";
    MetadataElementIdConstants["GLOBAL_QuestionDesicionId"] = "GLOBAL_QuestionDecision";
    MetadataElementIdConstants["GLOBAL_QuestionFromRole"] = "GLOBAL_QuestionFromRole";
    MetadataElementIdConstants["GLOBAL_QuestionToRole"] = "GLOBAL_QuestionToRole";
    MetadataElementIdConstants["GLOBAL_QuestionIdentifier"] = "GLOBAL_QuestionIdentifier";
    MetadataElementIdConstants["GLOBAL_QuestionResponsible"] = "GLOBAL_QuestionResponsible";
    MetadataElementIdConstants["GLOBAL_PublishedDateId"] = "GLOBAL_PublishedDate";
    MetadataElementIdConstants["GLOBAL_TabId"] = "GLOBAL_TabId";
    MetadataElementIdConstants["GLOBAL_WorkflowId"] = "GLOBAL_WorkflowId";
    MetadataElementIdConstants["GLOBAL_IssueTitle"] = "GLOBAL_Issue_Title";
    MetadataElementIdConstants["GLOBAL_InspectionStructureRoomId"] = "GLOBAL_Inspection_structure_room";
    MetadataElementIdConstants["GLOBAL_InspectionItemId"] = "GLOBAL_InspectionItemId";
    MetadataElementIdConstants["GLOBAL_InspectionCollectionId"] = "GLOBAL_InspectionCollectionId";
    MetadataElementIdConstants["GLOBAL_InspectionId"] = "GLOBAL_InspectionId";
    MetadataElementIdConstants["GLOBAL_DocumentVersionId"] = "GLOBAL_DocumentVersionId";
    MetadataElementIdConstants["GLOBAL_DocumentId"] = "GLOBAL_DocumentId";
    MetadataElementIdConstants["GLOBAL_FacilityId"] = "GLOBAL_FacilityId";
    MetadataElementIdConstants["GLOBAL_IssueItemInspectionsStatusElementId"] = "GLOBAL_IssueItemInspectionStatusElementId";
    MetadataElementIdConstants["GLOBAL_IssueDescription"] = "GLOBAL_Issue_Description";
    MetadataElementIdConstants["GLOBAL_TabType"] = "GLOBAL_TabType";
    MetadataElementIdConstants["GLOBAL_Status"] = "GLOBAL_Status";
    MetadataElementIdConstants["GLOBAL_RevisionDate"] = "GLOBAL_RevisionDate";
    MetadataElementIdConstants["GLOBAL_Description"] = "GLOBAL_Description";
    MetadataElementIdConstants["GLOBAL_Meetings"] = "GLOBAL_Meetings";
    MetadataElementIdConstants["GLOBAL_Version"] = "GLOBAL_Version";
    MetadataElementIdConstants["GLOBAL_ProjectRoleTypes"] = "GLOBAL_ProjectRoleTypes";
    MetadataElementIdConstants["GLOBAL_TechnicalArea"] = "GLOBAL_TechnicalArea";
    MetadataElementIdConstants["GLOBAL_Advisors"] = "GLOBAL_Advisors";
    MetadataElementIdConstants["GLOBAL_Entrepreneur"] = "GLOBAL_Entrepreneur";
    MetadataElementIdConstants["GLOBAL_QualityPlanRole"] = "GLOBAL_QualityPlanRole";
    MetadataElementIdConstants["GLOBAL_FacilityManagmentRoles"] = "GLOBAL_FacilityManagmentRoles";
    MetadataElementIdConstants["GLOBAL_Category"] = "GLOBAL_Category";
    MetadataElementIdConstants["GLOBAL_Supervisor"] = "GLOBAL_Supervisor";
    MetadataElementIdConstants["GLOBAL_ReminderInterval"] = "GLOBAL_ReminderInterval";
    MetadataElementIdConstants["GLOBAL_ContractRenewalDate"] = "GLOBAL_ContractRenewalDate";
    MetadataElementIdConstants["GLOBAL_ContractDate"] = "GLOBAL_ContractDate";
    MetadataElementIdConstants["GLOBAL_ContractStatus"] = "GLOBAL_ContractStatus";
    MetadataElementIdConstants["GLOBAL_EndDate"] = "GLOBAL_EndDate";
    MetadataElementIdConstants["GLOBAL_PublishedDate"] = "GLOBAL_PublishedDate";
    MetadataElementIdConstants["GLOBAL_ProjectSize"] = "GLOBAL_ProjectSize";
    MetadataElementIdConstants["GLOBAL_Date"] = "GLOBAL_Date";
    MetadataElementIdConstants["GLOBAL_Scale"] = "GLOBAL_Scale";
    MetadataElementIdConstants["GLOBAL_Name"] = "GLOBAL_Name";
    MetadataElementIdConstants["GLOBAL_Domain"] = "GLOBAL_Domain";
    MetadataElementIdConstants["GLOBAL_ContractId"] = "GLOBAL_ContractId";
    MetadataElementIdConstants["GLOBAL_IssuesUserDefined"] = "GLOBAL_IssuesUserDefined";
    MetadataElementIdConstants["GLOBAL_Tags"] = "GLOBAL_Tags";
    MetadataElementIdConstants["GLOBAL_AnnotationCount"] = "GLOBAL_AnnotationCount";
    MetadataElementIdConstants["GLOBAL_Connections"] = "GLOBAL_Connections";
    MetadataElementIdConstants["GLOBAL_Warranty"] = "GLOBAL_Warranty";
    MetadataElementIdConstants["GLOBAL_Maintenance"] = "GLOBAL_Maintenance";
    MetadataElementIdConstants["GLOBAL_MaintenanceId"] = "GLOBAL_MaintenanceId";
    MetadataElementIdConstants["GLOBAL_WarrantyStatus"] = "GLOBAL_WarrantyStatus";
    MetadataElementIdConstants["GLOBAL_MaintenanceStatus"] = "GLOBAL_MaintenanceStatus";
    MetadataElementIdConstants["GLOBAL_Product"] = "GLOBAL_Product";
    MetadataElementIdConstants["GLOBAL_Performance"] = "GLOBAL_Performance";
    MetadataElementIdConstants["GLOBAL_Responsible"] = "GLOBAL_Responsible";
    MetadataElementIdConstants["GLOBAL_TenderId"] = "GLOBAL_TenderId";
    MetadataElementIdConstants["GLOBAL_TenderVersionId"] = "GLOBAL_TenderVersionId";
    MetadataElementIdConstants["GLOBAL_TenderBidId"] = "GLOBAL_TenderBidId";
    MetadataElementIdConstants["GLOBAL_TenderSectionId"] = "GLOBAL_TenderSectionId";
    MetadataElementIdConstants["GLOBAL_OrganizationOwner"] = "GLOBAL_OrganizationOwner";
    MetadataElementIdConstants["GLOBAL_TenderAnnouncementId"] = "GLOBAL_TenderAnnouncementId";
    MetadataElementIdConstants["LEGACY_OrganizationId"] = "LEGACY_OrganizationId";
    MetadataElementIdConstants["GLOBAL_PropertyStructureId"] = "GLOBAL_PropertyStructureId";
    MetadataElementIdConstants["GLOBAL_PropertyId"] = "GLOBAL_PropertyId";
    MetadataElementIdConstants["GLOBAL_PhotoUrl"] = "GLOBAL_PhotoUrl";
    MetadataElementIdConstants["GLOBAL_IssuePriorityLabel"] = "GLOBAL_IssuePriorityLabel";
    MetadataElementIdConstants["GLOBAL_IssueSeriesLabel"] = "GLOBAL_IssueSeriesLabel";
    MetadataElementIdConstants["GLOBAL_IssueProblemLabel"] = "GLOBAL_IssueProblemLabel";
})(MetadataElementIdConstants || (MetadataElementIdConstants = {}));
//# sourceMappingURL=MetadataElementIdConstants.js.map